import React from 'react';

import { CompactListCard } from './compact-list-card';
import { CompactListCardProductContent } from './compact-list-card-product-content';
import { CompactListCardOfferContent } from './compact-list-card-offer-content';
import { CompactListCardMedia } from './compact-list-card-media';
import { CompactListCardPrice } from './compact-list-card-price';

import { BaseProps } from '../../types';

export const ProductCompactListCard: React.FC<BaseProps> = props => {
  const {
    id,
    diffPercentage,
    highlightedName,
    imageSrc,
    name,
    price,
    rating,
    reviewsCount,
    selectable,
    selected,
    type = 'product',
    link,
    onClick,
    className,
    container,
    background,
    onDeselect,
    onSelect,
    buttonAriaLabel,
    ActionArea,
    FooterArea,
    priceInclShipping,
    fallbackImageSrc,
    store,
  } = props;

  const cardProps = {
    id,
    link,
    className,
    container,
    background,
    selected,
    selectable,
    onClick,
    onDeselect,
    onSelect,
    buttonAriaLabel,
    ActionArea,
    FooterArea,
  };

  const productContentProps = {
    name,
    rating,
    highlightedName,
    reviewsCount,
  };
  const offerContentProps = { name, highlightedName, link, onClick, store };
  const mediaProps = {
    name,
    selectable,
    selected,
    fallbackImageSrc,
    imageSrc,
  };
  const priceProps = {
    price,
    diffPercentage,
    priceInclShipping,
    store,
  };

  // The card shouldn't be clickable for offers
  const isClickable = type === 'product';

  return (
    <CompactListCard {...cardProps} isClickable={isClickable}>
      <CompactListCardMedia {...mediaProps} />
      {type === 'product' && (
        <CompactListCardProductContent {...productContentProps} />
      )}
      {type === 'offer' && (
        <CompactListCardOfferContent {...offerContentProps} />
      )}

      <CompactListCardPrice
        {...priceProps}
        showFromPrice={type === 'product'}
      />
    </CompactListCard>
  );
};
